import Axios from "axios";
import { apiConfig } from "../constants/apiConfig";
import { keyCloakConstants } from "../constants/apiUrl";

const baseURL = apiConfig.auth;
let useAdminToken = true;

class KeyCloakService {
  private axiosInstance: any;

  onUnAuthorize() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/Login'
  }

  constructor() {
    this.axiosInstance = Axios.create({});

    this.axiosInstance.interceptors.response.use(
      (response: any) => response,
      async (error: any) => {
        const originalRequest = error.config;
        if (!(error?.response?.status === 401) && !originalRequest._retry && useAdminToken) {
          originalRequest._retry = true;

          try {
            const data: any = await this.getAdminToken();
            if (data && data.data.access_token) {
              localStorage.setItem("admin_token", data.data.access_token);

              originalRequest.headers["Authorization"] = "Bearer " + data.data.access_token;

              return this.axiosInstance(originalRequest);
            }
            else {
              console.error("No access token returned from refreshToken");
              this.onUnAuthorize();
            }
          } catch (refreshError) {
            this.onUnAuthorize();
          }
        }

        return error?.response;
      }
    );
  }

  authInfo = () => {

  }

  getConfig = () => {
    let token = localStorage.getItem("admin_token");
    if (token) {
      return {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
    } else {
      return null;
    }
  };

  encodedData(details: any) {
    var formBody: any = [];
    for (var property in details) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    return formBody
  }

  refreshToken = async () => {
    let appConfig: any = apiConfig.appConfig;
    let refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) {
      return null;
    }
    var details: any = {
      grant_type: appConfig.refreshTokenGrantType,
      client_id: appConfig.clientId,
      client_secret: appConfig.clientSecret,
      refresh_token: refreshToken,
    };

    useAdminToken = false;

    var formBody: any = this.encodedData(details);
    var promise = this.axiosInstance.post(
      baseURL + keyCloakConstants.TOKEN,
      formBody,
    );
    var result = await promise;
    localStorage.setItem("token", result.data.access_token);
    localStorage.setItem("refresh_token", result.data.refresh_token);
    return promise;
  }

  login = (url: string, data: { userName: string; password: string }, additionalConfigs?: object) => {
    let _data: any = {
      username: data.userName,
      password: data.password,
      grant_type: apiConfig.appConfig.grantType,
      client_id: apiConfig.appConfig.clientId,
      client_secret: apiConfig.appConfig.clientSecret,
    }

    var formBody: any = this.encodedData(_data);

    return this.axiosInstance.post(baseURL + url, formBody);
  };

  getAdminToken = () => {
    let _data: any = {
      grant_type: apiConfig.appConfig.adminGrantType,
      client_id: apiConfig.appConfig.clientId,
      client_secret: apiConfig.appConfig.clientSecret,
    }

    var formBody: any = this.encodedData(_data);
    return this.axiosInstance.post(baseURL + keyCloakConstants.TOKEN, formBody);
  }


  get = (url: string, additionalConfigs?: object) => {
    return this.axiosInstance.get(baseURL + url, {
      ...this.getConfig(),
      ...additionalConfigs,
    });

  };

  //   post = (url: string, data = {}, additionalConfigs?: object) => {
  //     return this.axiosInstance.post(baseURL + url, data, {
  //       ...this.getConfig(),
  //       ...additionalConfigs,
  //     });
  //   };

  //   put = (url: string, data = {}) => {
  //     return this.axiosInstance.put(baseURL + url, data, this.getConfig());
  //   };

  //   patch = (url: string, data = {}) => {
  //     return this.axiosInstance.patch(baseURL + url, data, this.getConfig());
  //   };

  //   delete = (url: string, data = {}) => {
  //     return this.axiosInstance.delete(baseURL + url, this.getConfig());
  //   };

  //   postFormData = async (url: string, formData: FormData) => {
  //     let formHeaders = {
  //       ...this.getConfig()?.headers,
  //       Accept: "application/json",
  //       "Content-Type": "multipart/form-data",
  //     };
  //     const options = {
  //       url: url,
  //       method: "POST",
  //       headers: formHeaders,
  //     };
  //     return await this.axiosInstance.post(baseURL + url, formData, options);
  //   };
}



export default new KeyCloakService();
